import React, { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'

import type { MenuItem } from '../../../models/types'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'

import HomeIcon from '../../Icons/RemoteIcons/HomeIcon'
import DashboardColumn from './DashboardColumn'

interface DashboardProps {
  toggleDashboard: () => void
}

const Dashboard = ({ toggleDashboard }: DashboardProps): JSX.Element => {
  const dispatch = useDispatch()
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const locale = useSelector((state: RootState) => state.localeReducer.locale)
  const localizedMenus = useSelector((state: RootState) => state.localeReducer.localizedMenus)
  const menus = useSelector((state: RootState) => state.retorikReducer.configuration.menu)

  const processedMenus = useMemo<Array<{ title?: string; tiles: Array<MenuItem> }>>(() => {
    return localizedMenus || menus?.categories
  }, [localizedMenus, menus])

  const handleHome = (): void => {
    dispatch(storeActions.directline.sendEvent({ name: 'showHome' }))
    toggleDashboard()
  }

  return (
    <div className='rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start'>
      {/* Home */}
      <div
        className='rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-text-trueblack rf-overflow-hidden'
        onClick={handleHome}
      >
        <HomeIcon className='rf-h-6 rf-w-8' color='#1999B1' />
        <div>{capitalizeFirstLetter(translation.home.shorttitle, locale)}</div>
      </div>

      {/* Other menus */}
      {processedMenus?.map((menu, key) => {
        return (
          <React.Fragment key={key}>
            <div className='rf-h-6 -rf-mx-8 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder' />
            <DashboardColumn {...menu} onClick={toggleDashboard} />
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Dashboard
